import http from '../../../service/axios';

export const promotionAPI = {
  // Тексты акций бэкенд отдаёт в `translations` на языке из заголовка
  // Language — как в /branch/positions2. Подборка зависит от филиала; если
  // он неизвестен, branch_id не уходит, как у баннеров.
  getDealsList: async (branchId?: number) =>
    await http.get('/deals/list', {
      params: { branch_id: branchId || undefined },
      headers: { Language: localStorage.getItem('language') || 'uz' },
    }),
};
